import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path
        d='M10.95 5.00073L10.9493 11.0005H4.9502L4.9502 13.0002L10.9493 13.0002L10.9493 18.9993H12.949V13.0002L18.9488 12.9995L18.9488 10.9998H12.9497L12.9497 5.00073L10.95 5.00073Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
